import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmailTemplatesById } from "../../redux/Slice/emailTemplate";
import { setLoading } from "../../redux/Slice/loaderSlice";
import { useNavigate, useParams } from "react-router-dom";

const TemplateView = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { selectedTemplate } = useSelector((state) => state.email);

  const [templateHtml, setTemplateHtml] = useState("");

  useEffect(() => {
    dispatch(setLoading(true));
    dispatch(fetchEmailTemplatesById(id)).then(() => {
      dispatch(setLoading(false));
    });
  }, [id, dispatch]);

  useEffect(() => {
    if (selectedTemplate?.codeContent) {
      const iframe = document.getElementById("templateIframe")?.contentWindow?.document;
      if (iframe) {
        iframe.open();
        iframe.write(selectedTemplate?.codeContent);
        iframe.close();
        const iframeHtmlString = iframe.documentElement.outerHTML;
        setTemplateHtml(iframeHtmlString);
      }
    }
  }, [selectedTemplate]);

 


  return (
    <div className="content">
      <Box sx={{ padding: 2 }}>
        <Typography variant="h4" mb={2}>
          {selectedTemplate?.name}
        </Typography>


        <Box
          sx={{
           
            padding: "10px",
          }}
        >
          <iframe
            id="templateIframe"
            title="HTML Code Preview"
            style={{
              width: "100%",
              height: "500px",
             
            }}
          />
        </Box>

        <Button
          variant="contained"
          color="primary"
          sx={{ "&:hover": { backgroundColor: "#2FB354" } }}
          onClick={() => navigate("/email")}
        >
          Back to Templates
        </Button>
      </Box>
    </div>
  );
};

export default TemplateView;
